<template>
  <div>
    <v-dialog v-model="dialog" persistent fullscreen="">
      <v-card
        style="position: fixed;top: 0;height:100vh;"
        flat
        :loading="loading"
      >
        <v-card-text>
          <div v-if="report_data.is_expire" class="text-center mt-5 error--text">
            <h2>This link has expired</h2>
          </div>
          <div v-if="report_data.is_view_only">
            <iframe
              :src="report_data.pdf_file"
              frameborder="0"
              style="width:100%;height:100vh"
            ></iframe>
          </div>
          <div v-else>
            <!-- <iframe
              :src="'https://docs.google.com/gview?embedded=true&url='+report_data.pdf_file"
              frameborder="0"
              style="width:100%;height:100vh"
            ></iframe> -->
            <iframe
              :src="preview_page_link"
              frameborder="0"
              style="width:100%;height:100vh"
            ></iframe>
            <div class="d-flex flex-row justify-space-between col-12 customimg" style="position:absolute;bottom:0px;">
              <div></div>
              <!-- <v-btn color="primary" class="mr-15" @click="(report_data.report == 4)?fill_ans_dialog = true:signature_dialog = true">
                Signature & Send
              </v-btn> -->
              <v-btn
                color="primary"
                class="text-capitalize mr-15"
                @click="(report_data.report == 4)?fill_ans_dialog = true:signature_dialog = true"
                v-if="total_page == active_page"
                :loading="loading"
              >Finish & Submit</v-btn>
              <v-btn
                v-else
                color="primary"
                class="text-capitalize mr-15"
                @click="signature_dialog = true;"
                :loading="loading"
              >Next Page</v-btn>
              
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="signature_dialog" max-width="500" persistent>
      <v-card :loading="signature_loading">
        <v-card-title class="headline">Signature</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" v-if="active_page == 1">
              <div class="container">
                <VueSignaturePad
                  id="customer_signature"
                  width="100%"
                  height="80px"
                  ref="customerSignaturePad"
                  :options="{onBegin: () => {$refs.customerSignaturePad.resizeCanvas()}}"
                />
              </div>
              <div class="mt-2 text-center error--text">
                {{erro_msg}}
              </div>
              <div class="mt-2 text-center">
                <v-btn
                  outlined
                  small=""
                  @click="$refs.customerSignaturePad.undoSignature()"
                >
                  Undo
                </v-btn>
                <v-btn
                  class="ml-2"
                  outlined
                  small=""
                  @click="$refs.customerSignaturePad.clearSignature()"
                >
                  Clear
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" v-else>
              <div class="container">
                <img :src="customer_sign_blob" />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="signature_dialog = false; (active_page == 1)?$refs.customerSignaturePad.clearSignature():'';" class="error">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="saveSignature()"
            :loading="signature_loading"
          >{{(active_page == 1)?'Ok':'Accept & Sign'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="fill_ans_dialog" max-width="800" persistent>
      <v-card :loading="signature_loading">
        <v-card-title class="headline">Fill Answer & Signature</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border">
                <tbody>
                  <tr v-for="(row, index) in items" :key="index">
                    <td width="7%" class="pa-1">
                      <v-btn block :color="(row.answer == 1)?'blue-grey darken-2':'grey'" class="text-capitalize rounded-0" :class="(row.answer == 1)?'white--text':''" @click="row.answer = 1;">
                        Yes
                      </v-btn>
                    </td>
                    <td width="7%" class="pa-1">
                      <v-btn block :color="(row.answer == 2)?'blue-grey darken-2':'grey'" class="text-capitalize rounded-0" :class="(row.answer == 2)?'white--text':''" @click="row.answer = 2;">
                        No
                      </v-btn>
                    </td>
                    <td width="7%" class="pa-1">
                      <v-btn block :color="(row.answer == 3)?'blue-grey darken-2':'grey'" class="text-capitalize rounded-0" :class="(row.answer == 3)?'white--text':''" @click="row.answer = 3;">
                        N/A
                      </v-btn>
                    </td>
                    <td>
                      {{replace_text(row.text)}}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="4" class="mx-auto mt-3">
              <div class="container">
                <VueSignaturePad
                  id="customer_signature"
                  width="100%"
                  height="80px"
                  ref="customerSignaturePad"
                  :options="{onBegin: () => {$refs.customerSignaturePad.resizeCanvas()}}"
                />
              </div>
              <div class="mt-2 text-center error--text">
                {{erro_msg}}
              </div>
              <div class="mt-2 text-center">
                <v-btn
                  outlined
                  small=""
                  @click="$refs.customerSignaturePad.undoSignature()"
                >
                  Undo
                </v-btn>
                <v-btn
                  class="ml-2"
                  outlined
                  small=""
                  @click="$refs.customerSignaturePad.clearSignature()"
                >
                  Clear
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12"></v-col>
            <v-col cols="8" class="mx-auto mt-3" v-if="report_data.report == 4">
              <h3>Note: </h3>
              <v-textarea
                v-model="note"
                outlined=""
                rows="3"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="fill_ans_dialog = false; (active_page == 1)?$refs.customerSignaturePad.clearSignature():''" class="error">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="saveSignature()"
            :loading="signature_loading"
          >{{(active_page == 1)?'Ok':'Accept & Sign'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../plugins/axios";
import { mapMutations } from "vuex";
 export default {
   data() {
     return {
      dialog: true,
      loading: false,
      report_data: '',
      signature_dialog: false,
      signature_loading: false,
      fill_ans_dialog: false,
      erro_msg: '',
      items: [],
      display_data: true,
      note: '',
      total_page: '',
      active_page: 0,
      preview_page_link: '',
      customer_sign_blob: '',
      user_sign: [],
     }
   },
   methods: {
     ...mapMutations("utils", ["setAlert"]),
    replace_text(text) {
      return text.replace("{company_name}", this.report_data.data.company_details.name);
    },
    generatePDF(is_past_page) {
      this.erro_msg = ''
      this.active_page++;
      let data = {
        company_id: this.$route.params.company_id,
        project_id: this.report_data.project_id,
        unique_id: this.$route.params.unique_id,
        user_sign_blob: this.user_sign,
        flag: 'mail',
        user_name: this.report_data.user_id,
        email_ids: this.report_data.email_ids,
        email_id_arr: [{
          email: this.report_data.email_ids
        }],
        is_customer_submit: 'yes',
        items: this.items,
        note: this.note,
        active_page: this.active_page,
        total_page: this.total_page
      }
      if(is_past_page) {
        data.generate_pdf_flag = 'whole_page';
        data.customer_sign_blob = this.customer_sign_blob;
      } else {
        data.generate_pdf_flag = 'single_page';
      }
      let action_url = ''
      if(this.report_data.report == 1) {
        action_url = 'generate_sales_invoice_pdf'
      } else if(this.report_data.report == 2) {
        action_url = 'generate_counter_pdf'
      } else if(this.report_data.report == 3) {
        action_url = 'generate_acceptance_pdf'
      } else if(this.report_data.report == 4) {
        action_url = 'generate_sign_off_pdf'
      } else {
        let report_name = ''
        if(this.report_data.report == 5) {
          report_name = 'g_702'
        } else if(this.report_data.report == 6) {
          report_name = 'g_703'
        } else if(this.report_data.report == 7) {
          report_name = 'contract'
        } else if(this.report_data.report == 8) {
          report_name = 'partial_lien_release'
        } else if(this.report_data.report == 9) {
          report_name = 'final_lien_release'
        }
        data.report_name = report_name;
        action_url = 'generate_invoice_pdf'
      }
      this.signature_loading = true;
      axios
      .post(action_url,data)
      .then(response => {
        if(is_past_page) {
          if(response.data.status) {
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
          }
          this.display_data = false;
          this.fill_ans_dialog = false;
          this.getReportData();
        } else {
          this.preview_page_link = response.data.preview_page_link;
        }
        this.signature_dialog = false;
        this.signature_loading = false;
      })
      .catch(function(error) {
        console.log(error);
        this.signature_loading = false;
      }); 
    },
    saveSignature() {
      if(this.active_page == 1) {
        let customerImageData = this.$refs.customerSignaturePad.saveSignature('image/png');
        if(!customerImageData.isEmpty) {
          this.customer_sign_blob = customerImageData.data;
          if(this.total_page == this.active_page) {
            this.generatePDF(true);
          } else {
            this.generatePDF(false);
          }
          this.$refs.customerSignaturePad.clearSignature()
        } else {
          this.erro_msg = "Please fill signature"
        }
      } else {
        if(this.total_page == this.active_page) {
          this.generatePDF(true);
        } else {
          this.generatePDF(false);
        }
      }
    },
     getReportData() {
        let _self = this;
        this.loading = true;
        axios
        .get("get_report_preview_data?company_id="+this.$route.params.company_id+"&unique_id="+this.$route.params.unique_id)
        .then(response => {
          _self.report_data = response.data.data;
          _self.user_sign = response.data.user_sign;
          if(_self.report_data.report == 4) {
            console.log(_self.report_data)
            _self.items = _self.report_data.data.items;
          }
          _self.loading = false;
          this.getTotalPage();
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
      },
      getTotalPage() {
        let data = {
          company_id: this.$route.params.company_id,
          project_id: this.report_data.project_id,
          unique_id: this.$route.params.unique_id,
          user_name: this.report_data.user_id,
          user_sign_blob: this.user_sign,
          is_customer_submit: 'yes',
          items: this.items,
          note: this.note,
          generate_pdf_flag: 'get_total'
        }
        let action_url = ''
        if(this.report_data.report == 1) {
          action_url = 'generate_sales_invoice_pdf'
        } else if(this.report_data.report == 2) {
          action_url = 'generate_counter_pdf'
        } else if(this.report_data.report == 3) {
          action_url = 'generate_acceptance_pdf'
        } else if(this.report_data.report == 4) {
          action_url = 'generate_sign_off_pdf'
        } else {
          let report_name = ''
          if(this.report_data.report == 5) {
            report_name = 'g_702'
          } else if(this.report_data.report == 6) {
            report_name = 'g_703'
          } else if(this.report_data.report == 7) {
            report_name = 'contract'
          } else if(this.report_data.report == 8) {
            report_name = 'partial_lien_release'
          } else if(this.report_data.report == 9) {
            report_name = 'final_lien_release'
          }
          data.report_name = report_name;
          action_url = 'generate_invoice_pdf'
        }
        axios
        .post(action_url,data)
        .then(response => {
          if(response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.generatePDF(false);
        })
        .catch(function(error) {
          console.log(error);
        }); 
      },
    },
    mounted: function () {
      this.getReportData();
    }
 }
 </script>
 <style scoped>
.container {
  width: "100%";
  padding: 8px 16px;
  border: solid 1px;
}
 </style>